"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function defaultUpdateLocation(location, newParams, anchor) {
    var hash;
    if (anchor) {
        hash = "#" + anchor;
    }
    return {
        pathname: location.pathname,
        query: updateParams(location.query, newParams),
        hash: hash,
    };
}
exports.defaultUpdateLocation = defaultUpdateLocation;
function updateParams(currentParams, newParam) {
    var newParams = Object.assign({}, currentParams, newParam);
    if (!('page' in newParam) || parseInt(newParam.page, 10) <= 1) {
        delete newParams.page;
    }
    Object.keys(newParams).forEach(function (key) {
        var values = newParams[key];
        // If a param is an array of length 1, unwrap and just return the value
        if (values && values.length === 1) {
            newParams[key] = values[0];
        }
    });
    return lodash_1.pickBy(newParams, function (val) { return lodash_1.isNumber(val) || !lodash_1.isEmpty(val); });
}
exports.updateParams = updateParams;
//# sourceMappingURL=update_params.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/update_params.js
// module id = LDHI
// module chunks = 0 1 2 3 4 9 10 14 20